import React, { useState } from "react";
import { apiGet, apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import AuthContext from "./AuthContext";
import { isEmpty } from "lodash";
import moment from "moment";
import { createContext, useContextSelector } from "use-context-selector";
const BetSlipContext = createContext();

export default BetSlipContext;

export const BetSlipProvider = ({ children }) => {
  const setBetLoader = useContextSelector(AuthContext, (ctx) => {
    return ctx.setBetLoader;
  });
  const betLoader = useContextSelector(AuthContext, (ctx) => {
    return ctx.betLoader;
  });

  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const amounutRefresh = useContextSelector(AuthContext, (ctx) => {
    return ctx.amounutRefresh;
  });
  const [toastObject, setToastObject] = useState({
    message: "",
    status: false,
    type: "",
    title: "",
  });
  const [oneClickBetLoader, setOneClickBetLoader] = useState("");
  const [limit, setLimit] = useState({});
  const [resetBetPosition, setResetBetPosition] = useState(false);
  const [showBetDialog, setShowBetDialog] = useState(false);
  const [betPlace, setBetPlace] = useState({
    isPlaced: false,
    betType: "",
    type: "",
  });
  const [betSlipObject, setBetSlipObject] = useState({
    odds: "",
    bidPrice: "",
    teamName: "",
    betType: "",
  });
  const handleError = (message, type, id) => {
    setToastObject({
      type: "error",
      title: "Bet Error",
      message: message,
      status: true,
      gameType: type,
      id: id,
    });
  };
  const handleSuccess = (message) => {
    setToastObject({
      type: "success",
      title: "Bet Placed",
      message: message?.message,
      status: true,
      playType: message?.type,
      gameType: message?.gameType,
      id: message?.id,
    });
  };
  const handelPlaceBetFair = async (limit, obj) => {
    let newObj = !isEmpty(obj) ? obj : betSlipObject;
    if (!isEmpty(user) && newObj?.bidPrice > 0) {
      setBetLoader(true);
      const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
      let result = {
        eventId: newObj?.object?.eventId,
        marketId: newObj?.newMarketId,
        betPlaceTime: date,
        betPlaceType: "betfair",
        bet: [
          {
            selectionId: newObj?.object?.SelectionId || newObj?.object?.ri,
            teamName: newObj?.teamName || newObj?.object?.runnerName,
            bhav: newObj?.odds,
            amount: newObj?.bidPrice,
            betType: newObj?.betType,
          },
        ],
      };

      const { status, data: response_users } = await apiPost(
        apiPath.betfairPlaceBet,
        result,
      );
      if (status === 200) {
        if (response_users?.success) {
          if (response_users?.results?.matchedFlag) {
            setResetBetPosition(true);
            setBetPlace({
              isPlaced: true,
              betType: "betFair",
              type: "matched",
            });
            amounutRefresh();
            handleSuccess({
              message: `${newObj?.teamName || newObj?.object?.runnerName} | ${
                newObj?.odds
              } | BDT ${newObj?.bidPrice} `,
              type: newObj?.betType,
              gameType: "betfair",
            });
          } else {
            setBetSlipObject({});
            setBetPlace({
              isPlaced: false,
              betType: "betFair",
              type: "error",
            });
          }
        } else {
          handleError(response_users?.message, "betfair");
          setResetBetPosition(true);
          setBetPlace({
            isPlaced: true,
            betType: "betFair",
            type: "error",
          });
        }
      } else {
        handleError(response_users?.message, "betfair");
        setResetBetPosition(true);
        setBetPlace({
          isPlaced: true,
          betType: "betFair",
          type: "error",
        });
      }
    }
    setShowBetDialog(false);
    setBetLoader(false);
  };

  const handelPlaceBookmaker = async (limit, obj) => {
    let newObj = !isEmpty(obj) ? obj : betSlipObject;
    if (!isEmpty(user) && newObj?.bidPrice > 0) {
      setBetLoader(true);
      const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
      let result = {
        eventId: newObj?.object?.eventId,
        marketId: newObj?.object?.marketId,
        selectionId: newObj?.object?.SelectionId,
        betPlaceTime: date,
        teamName: newObj?.teamName || newObj?.object?.runnerName,
        bhav: newObj?.odds,
        amount: newObj?.bidPrice,
        betType: newObj?.betType,
        betPlaceType: "bookmaker",
      };
      const { status, data: response_users } = await apiPost(
        apiPath.bookmakerBet,
        result,
      );
      if (status === 200) {
        if (response_users?.success) {
          setShowBetDialog(false);
          setResetBetPosition(true);
          setBetPlace({
            isPlaced: true,
            betType: "bookmaker",
            type: "matched",
          });
          amounutRefresh();
          handleSuccess({
            message: `${newObj?.teamName || newObj?.object?.runnerName} | ${
              newObj?.odds
            } | BDT ${newObj?.bidPrice} `,
            type: newObj?.betType,
            gameType: "bookmaker",
            id: newObj?.object?.SelectionId,
          });
        } else {
          handleError(
            response_users?.message,
            "bookmaker",
            newObj?.object?.SelectionId,
          );
          setResetBetPosition(true);
          setBetPlace({
            isPlaced: false,
            betType: "bookmaker",
            type: "error",
          });
        }
      } else {
        handleError(
          response_users?.message,
          "bookmaker",
          newObj?.object?.SelectionId,
        );
        setResetBetPosition(true);
        setBetPlace({
          isPlaced: true,
          betType: "bookmaker",
          type: "error",
        });
      }
    }
    setShowBetDialog(false);
    setBetLoader(false);
  };
  const handelPlaceFancy = async (limit, obj) => {
    let newObj = !isEmpty(obj) ? obj : betSlipObject;
    if (!isEmpty(user) && newObj?.bidPrice > 0) {
      setBetLoader(true);
      const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
      const result = {
        eventId: newObj?.object?.eventId,
        marketId: newObj?.object?.marketId,
        centralizedId: newObj?.object?.centralizedId,
        selectionId: newObj?.object?.selectionId,
        betPlaceTime: date,
        fancyName: newObj?.object?.fancyName,
        bhav: newObj?.object?.pt,
        amount: newObj?.bidPrice,
        betType: newObj?.betType,
        betRun: newObj?.object?.rt,
        runnerName: newObj?.object?.fancyName,
        betPlaceType: "fancy",
      };
      let api = apiPath.fancyBetPlace;
      const { status, data: response_users } = await apiPost(api, result);
      if (status === 200) {
        if (response_users?.success) {
          setShowBetDialog(false);
          setResetBetPosition(true);
          amounutRefresh();
          setBetPlace({
            isPlaced: true,
            betType: "fancy",
            type: "matched",
          });
          handleSuccess({
            message: `${newObj?.object?.fancyName} | ${newObj?.object?.pt} / ${newObj?.object?.rt} | BDT ${newObj?.bidPrice} `,
            type: newObj?.betType,
            gameType: "fancy",
            id: newObj?.object?.centralizedId,
          });
        } else {
          handleError(
            response_users?.message,
            "fancy",
            newObj?.object?.centralizedId,
          );
          setResetBetPosition(true);
          setBetPlace({
            isPlaced: false,
            betType: "fancy",
            type: "error",
          });
        }
      } else {
        handleError(
          response_users?.message,
          "fancy",
          newObj?.object?.centralizedId,
        );
        setResetBetPosition(true);
        setBetPlace({
          isPlaced: false,
          betType: "fancy",
          type: "error",
        });
      }
    }
    setShowBetDialog(false);
    setBetLoader(false);
  };
  const handelPlaceSportBook = async (limit, obj) => {
    let newObj = !isEmpty(obj) ? obj : betSlipObject;
    if (!isEmpty(user) && newObj?.bidPrice >= 1) {
      setBetLoader(true);
      const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
      const result = {
        eventId: newObj?.eventId,
        marketId: newObj?.marketId,
        fancySelectionId: newObj?.object?.id,
        selectionId: newObj?.item?.id,
        betPlaceTime: date,
        fancyName: newObj?.item?.marketName,
        bhav: newObj?.odds,
        amount: newObj?.bidPrice,
        betType: "back",
        runnerName: newObj?.object?.selectionName,
        apiSiteSelectionId: newObj?.object?.apiSiteSelectionId,
        betPlaceType: "premiumFancy",
      };

      let api = apiPath.preminumFancyBets;
      const { status, data: response_users } = await apiPost(api, result);
      if (status === 200) {
        if (response_users?.success) {
          setShowBetDialog(false);
          setResetBetPosition(true);
          amounutRefresh();
          setBetPlace({
            isPlaced: true,
            betType: "sportBook",
            type: "matched",
          });

          handleSuccess({
            message: `${newObj?.object?.selectionName} | ${newObj?.odds} | BDT ${newObj?.bidPrice} `,
            type: "back",
            gameType: "sportbook",
            id: newObj?.object?.id,
          });
        } else {
          handleError(response_users?.message, "sportbook", newObj?.object?.id);
          setResetBetPosition(true);
          setBetPlace({
            isPlaced: false,
            betType: "sportBook",
            type: "error",
          });
        }
      } else {
        handleError(response_users?.message, "sportbook", newObj?.object?.id);
        setResetBetPosition(true);
        setBetPlace({
          isPlaced: false,
          betType: "sportBook",
          type: "error",
        });
      }
    }
    setShowBetDialog(false);
    setBetLoader(false);
  };

  let contextData = {
    betLoader,
    setBetLoader,
    limit,
    setLimit,
    showBetDialog,
    setShowBetDialog,
    betPlace,
    setBetPlace,
    betSlipObject,
    setBetSlipObject,
    resetBetPosition,
    setResetBetPosition,
    handelPlaceBetFair,
    oneClickBetLoader,
    setOneClickBetLoader,
    handelPlaceBookmaker,
    handelPlaceFancy,
    handelPlaceSportBook,
    toastObject,
    setToastObject,
  };
  return (
    <BetSlipContext.Provider value={contextData}>
      {children}
    </BetSlipContext.Provider>
  );
};
